
/*
 * @Descripttion: 月球样本
 * @version:
 * @Author: jerry
 * @Date: 2022-10-09
 * @LastEditors: jerry
 * @LastEditTime: 2022-10-09
 */
import * as config from "./config";
// 获取月球样本数据
export const getMoonSampleList = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/sample/data/list';

// 修改样本信息
export const editMoonSample = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/sample/data';

// 获取月球样本分类数据
export const getMoonSampleTypeList = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/sample/category/list';

// 根据状态统计月球样品的统计数量数据
export const getMoonSampleStatusCount = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/sample/data/status/count';

// 获取样品新闻数据
export const getMoonSampleNewList = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/sample/news/list';


// 获取我的样品、月球样品借用返还
export const getMoonSampleBorrowingReturn = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/sample/order/list';


// 添加月球样品借用返还
export const addMoonSampleBorrowingReturn = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/sample/order';

// 修改月球样品借用返还
export const updateOrder = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/sample/order';


// 发布月球样品数据
export const samplePublish = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/sample/data/publish';

// 关于我们
export const sampleAboutUS = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/cms/aboutUsList';

// 新增订单返还信息
export const addReturn = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/sample/return';


// 新增订单借用信息
export const addBorrow = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/sample/borrow';

// 轮播图  /client/cms/carouselImageList
export const imageList = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/cms/carouselImageList?pageNum=1&pageSize=100&type=2';

// 客户端用户点击详情时调用
export const viewsInfo = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/sample/data/views';


// 新增月球样品借用返还-使用记录
export const addRecord = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/sample/record';

// 新增延期请求
export const addDelay = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/sample/delay';


// // 分析数据
// export const getMoonSampleTypeList = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/sample/category/list';

// // 分心报告
// export const getMoonSampleTypeList = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/sample/category/list';

// // 辅助数据
// export const getMoonSampleTypeList = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/sample/category/list';


//  使用单位的那些信息
export const systemDeptList = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/system/dept/list';


//  申请再提交
export const failedListSubmit = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/sample/order/failedList';

//  浏览次数
export const addNews = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/cms/sample/news';
